// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1___4e20df3cbd89bb6f0ad","cls2":"NewsHeader-cls2__e2e6b84175681f34506a NewsHeader-cls1___4e20df3cbd89bb6f0ad"};